






































































































































































































































































































































































































































































































































































































































































































































































































import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import {
  ShoppingCart,
  Step,
  AddressInfo,
  CountryState,
  BasketHeader,
  CardPaymentForm,
  EcheckPaymentForm,
  CompleteOrderRequest,
} from './types/types';
import { SwSteps } from '@libs-uuif/shared/sw-steps';
import {
  wizardSteps,
  initialAddressInfo,
  DEFAULT_TEXTFIELD_WIDTH,
  eCheckAcTypes,
  imageMappings,
  initialCardPaymentForm,
  initialEcheckPaymentForm,
  months,
  initialCompleteOrderRequest,
} from './constants/checkout-constants';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { MswAppTitle } from '@/shared/msw-app-title';
import uuifComponent from '@/shared/uuifComponent';
import { InfoState } from '../../core/core.store';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';
import { SwForm, SwFormRow } from '@libs-uuif/shared/sw-form';
import { SwTextfield } from '@libs-uuif/shared/sw-textfield';
import { SwActionBar, SwActionBarItem } from '@libs-uuif/shared/sw-action-bar';
import { required, email, maxLength, helpers, minLength, numeric } from 'vuelidate/lib/validators';
import _ from 'lodash';
import RegexValidators from '@/shared/regex-validators';
import CheckOutShoppingCart from './components/checkout-shopping-cart.vue';
import { SelectOption } from '@sonicwall/unified-ui-framework/src/shared/sw-select/types';
import { StateList } from '../../shared/statesList';
import { TableColumnConfig, TableEntry } from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { envCongif } from '@/shared/env.config';
import { CreateElement, VNode } from 'vue';
import { Country, State } from '../../shared/country-state-component/types';
import  EncryptAesService  from '@/shared/encryptAesService';
const cssPrefix = 'checkoutPage';
const addressCheck = helpers.regex('addressCheck', new RegExp(RegexValidators.address));
const postalCode = helpers.regex('postalCode', new RegExp(RegexValidators.postalCode));
const phone = helpers.regex('phone', new RegExp(RegexValidators.phoneNo));
const noSpecialChars = helpers.regex('specialCharacterCheck', new RegExp(RegexValidators.noSpecialChars));
const noSpecialCharsExceptSpace = helpers.regex('noSpecialCharsExceptSpace', new RegExp(RegexValidators.noSpecialCharsExceptSpace));
// const validateGst = helpers.regex('validateGst', new RegExp(RegexValidators.gstPattern));
@Component({
  components:{
    SwSteps,
    MswAppTitle,
    ...uuifComponent,
    SwCheckbox,
    SwTextfield,
    SwFormRow,
    SwForm,
    SwActionBar,
    SwActionBarItem,
    CheckOutShoppingCart,
  },
  validations: {
    addressInfo: {
      fullName: { required, maxLength: maxLength(50) },
      address1: { required, addressCheck, maxLength: maxLength(50) },
      address2: { addressCheck, maxLength: maxLength(50)  },
      city: { required, addressCheck, maxLength: maxLength(50) },
      zipcode: { required, postalCode, maxLength: maxLength(50) },
      phone: { required, phone },
      province: { required, addressCheck },
      country: { required },
      state: { required },
      emailAddress: { required, email },
      vatNumber:  { required },
      gstNumber:  { required },
    },
    cardPaymentForm: {
      cardNumber: { required, minLength: minLength(12) },
      cvv: { required,  minLength: minLength(3) },
    },
    echeckPaymentForm: {
      bankName: { required, noSpecialCharsExceptSpace },
      routingNo: { required, noSpecialChars, onlyNumeric: numeric },
      acNumber: { required, noSpecialChars },
      nameOnAc: { required, noSpecialCharsExceptSpace },
      dlNumber: { required, noSpecialChars },
    },
  },
})
export default class CheckOutPage extends SwExtendedVue {
  cssPrefix = cssPrefix;

  fieldWidth: string = DEFAULT_TEXTFIELD_WIDTH.toString();

  steps: Step[] = [...wizardSteps];
  orderDetailsConfig: TableColumnConfig[] = [];
  countries: any = [];
  states: any = [];

  shoppingCart: ShoppingCart = {};
  cardDetails: any = {};
  orderItems: any = {};
  basketDetails: any = {};
  confirmBasketDetails: any = {};
  addressInfo: AddressInfo = { ...initialAddressInfo };
  objheader: BasketHeader = {};
  initCountrystate: CountryState = {};
  cardPaymentForm: CardPaymentForm = { ...initialCardPaymentForm };
  echeckPaymentForm: EcheckPaymentForm = { ...initialEcheckPaymentForm };
  completeorderrequest: CompleteOrderRequest = { ...initialCompleteOrderRequest };

  customerAddrID: string = '';
  payTokenId:string = '';
  tokenPaymentMethod: string = '';
  tokenCCType: string = '';
  tokenImgCardType: string = '';
  orderID: string = '';
  ccExpDate: string = '';
  selectedYear: string = '';
  selectedMonth: string = '';
  selectedCardType: string = 'none';
  imgCardType: string = '';
  tokenImgCard: string = '';
  orderDetailErrorMessage: string = '';
  useAddress: string = '';

  isAutoRenew: boolean = false;
  checkboxEnable: boolean = false;
  isguestbuynow: boolean = false;
  showVat: boolean = false;
  showGst: boolean = false;
  isCountryStateVaild: boolean = false;
  isSaveAddress: boolean = false;
  ckeckboxEnable: boolean = false;
  isCreatenew: boolean = false; // revisit
  addressUpdated: boolean = false;
  tokenExists: boolean = false;
  payEType: boolean = false;
  payWithECheck: boolean = false;
  isCCDataEditable: boolean = false;
  isCardTypeErr: boolean = false;
  isConditionsRead: boolean = false;
  isConditionsChecked: boolean = false;
  hasStates: boolean = false;
  isOrderConfirmed: boolean = false;
  isFilterUsersColumn: boolean = false;

  get getInitialValue() {
    return this.addressInfo ? this.addressInfo : {};
  }

  get getWidthConfig() {
    const widthConfig = {
      label: 50,
      field: 50,
    };
    return widthConfig;
  }

  get getObjHeader() {
    return this.objheader;
  }

  get getShoppingCartValues() : ShoppingCart {
    return this.shoppingCart;
  }

  get getDLStateOptions(): SelectOption[] {
    const temp: SelectOption[] = [];
    const filteredState = [...StateList['US']];
    filteredState.forEach((state: any) => {
      temp.push({ id: state.stateCode, label: `${this.$t(state.stateName)}`, value: state.stateCode  });
    });
    return temp;
  }

  get getMonthsOptions(): SelectOption[] {
    return months;
  }

  get getImgCardType() {
    if (!this.imgCardType) {
      return '';
    }
    return this.imgCardType;
  }

  get getTokenImgCardType() {
    if (!this.tokenImgCardType) {
      return '';
    }
    return this.tokenImgCardType;
  }

  get getYearsOptions(): SelectOption[] {
    const years: SelectOption[] = [];
    const yr = (new Date()).getFullYear();
    for (let i = 0; i < 11; i += 1) {
      years.push({ id: String(yr + i), label: String(yr + i), value: String(yr + i) });
    }
    return years;
  }

  get getacTypeOptions(): SelectOption[] {
    return eCheckAcTypes;
  }

  get getOrderDetailsConfig(): TableColumnConfig[] {
    this.orderDetailsConfig = [{
      key: 'description',
      dataKey: 'description',
      title: 'Description',
      scalable: true,
      width: 150,
      render:(h: CreateElement, data: { entry: TableEntry }): VNode => { // tslint:disable-line
        return this.descriptionVNode(h, data);
      },
    }, {
      key: 'quantity',
      dataKey: 'quantity',
      title: this.$t('checkout.qty')
        .toString(),
      width: 80,
      scalable: true,
      render: (createElement, data: { entry: TableEntry }) => {
        return createElement('div', { domProps: { innerHTML: data.entry.quantity } });
      },
    }, {
      key: 'users',
      dataKey: 'users',
      title: this.$t('checkout.users')
        .toString(),
      width: 150,
      scalable: true,
      render: (createElement, data: { entry: TableEntry }) => {
        return createElement('div', { domProps: { innerHTML: data.entry.nodeCount } });
      },
    }, {
      key: 'actkeys',
      dataKey: 'actkeys',
      title: this.$t('forgotusername.Activationkey')
        .toString(),
      width: 150,
      scalable: true,
      render: (h: CreateElement, data: { entry: TableEntry }) => {
        return this.activationKeysColumn(h, data);
      },
    }, {
      key: 'status',
      dataKey: 'status',
      title: this.$t('products.status')
        .toString(),
      width: 150,
      scalable: true,
      render: (h: CreateElement, data: { entry: TableEntry }) => {
        return this.statusColumn(h, data);
      },
    }];
    if (this.isFilterUsersColumn) {
      this.orderDetailsConfig = this.orderDetailsConfig.filter((coloumn: TableColumnConfig) => {
        return coloumn.key !== 'users';
      });
    }
    return this.orderDetailsConfig;
  }

  get getOrderDetailsData(): TableEntry[] {
    const tempArray: TableEntry[] = [];
    this.orderItems.arrOrderItems &&
    this.orderItems.arrOrderItems.length > 0 &&
    this.orderItems.arrOrderItems.forEach((arrOrderItem: any, index: number) => {
      tempArray.push({
        ...arrOrderItem,
        _key: index.toString(),
      });
    });
    return tempArray;
  }

  get countriesOptions() : SelectOption[]  {
    const tempArr: SelectOption[] = [];
    this.countries.map((country: Country) => {
      tempArr.push({
        id: country.countryCode ? country.countryCode : '',
        value: country.countryCode ? country.countryCode : '',
        label: country.countryName ? country.countryName : '',
      });
    });
    return tempArr;
  }

  get statesOptions() : SelectOption[] {
    const tempArr: SelectOption[] = [];
    this.states = this.addressInfo.country === 'US' ? [...StateList.US] :
       this.addressInfo.country === 'CA' ? [...StateList.CA] : [];
    this.states && this.states.map((state: State) => {
      tempArr.push({
        id: state.stateCode ? state.stateCode : '',
        value: state.stateCode ? state.stateCode : '',
        label: state.stateName ? `${this.$t(state.stateName)}` : '',
      });
    });
    return tempArr;
  }

  get getConfirmOrderImage() {
    return imageMappings['confirm_order'].path || '';
  }

  @Watch('objheader', { deep: true })
  private onChangeObjHeader() {
    this.objheader = _.clone(this.objheader);
  }

  created() {
    this.setInitialConfiguration();
  }

  async setInitialConfiguration() {
    this.steps[0].stepState = 'default';
    this.steps[1].stepState = 'default';
    this.steps[2].stepState = 'default';
    this.orderID = this.$store.getters['CheckoutStoreModule/getOrderIdFromQuote'] || '';
    if (this.$router.currentRoute.query.orderID) {
      this.orderID = this.$router.currentRoute.query.orderID.toString();
    }
    if (this.orderID) {
      this.steps[2].stepState = 'complete';
      this.$store.commit('CheckoutStoreModule/mutate', { property: 'orderId', with: '' });
      this.getOrderDetails(true, '');
    } else {
      await this.getShoppingCart();
    }
  }

  async getShoppingCart() {
    await this.$store.dispatch('CatalogStoreModule/getBasketDetails')
      .then((response: any) => {
        this.$store.commit('stopLoading');
        if (response.operationStatus === 'OK') {
          this.shoppingCart.items = response.hasOwnProperty('content') ?
                                    response.content.hasOwnProperty('basketItems') ?
                                    response.content.basketItems : [] : [];
          this.shoppingCart.price = response.hasOwnProperty('content') ?
                                    response.content.hasOwnProperty('basketDetails') ?
                                    response.content.basketDetails.totalPrice : 0 : 0;
          this.shoppingCart.tax =  response.hasOwnProperty('content') ?
                                   response.content.hasOwnProperty('basketDetails') ?
                                   response.content.basketDetails.hasOwnProperty('totalTax') ?
                                   response.content.basketDetails.totalTax : 0 : 0 : 0;
          this.shoppingCart.id =   response.hasOwnProperty('content') ?
                                   response.content.hasOwnProperty('basketDetails') ?
                                   response.content.basketDetails.hasOwnProperty('basketId') ?
                                   response.content.basketDetails.basketId : '' : '' : '';
          this.basketDetails = response.hasOwnProperty('content') &&
                               response.content.hasOwnProperty('basketDetails') ?
                               response.content.basketDetails : {};
          this.customerAddrID = response.hasOwnProperty('content') ?
                                response.content.hasOwnProperty('basketDetails') ?
                                response.content.basketDetails.hasOwnProperty('customerAddressID') ?
                                response.content.basketDetails.customerAddressID : '' : '' : '';
          if (this.shoppingCart.items && this.shoppingCart.items.length > 0) {
            for (let i = 0; i <  this.shoppingCart.items.length; i += 1) {
              if (this.shoppingCart.items[0].isAutoRenew === true) {
                this.isAutoRenew = true;
                break;
              }
            }
          }
          if (!_.isEmpty(this.basketDetails)) {
            this.setBillingAddress();
          }
          this.cardPaymentForm.year = response.content.currentYear ?
          response.content.currentYear :
           (new Date()).getFullYear()
           .toString();
          this.cardPaymentForm.month =  response.content.currentMonth || '';
          this.echeckPaymentForm.eCheckSelectedAcType = eCheckAcTypes[0].id.toString();
          this.echeckPaymentForm.dlState = this.getDLStateOptions[0].id.toString();
          this.cardDetails = response.hasOwnProperty('content') &&
                             response.content.hasOwnProperty('cardDetails') ?
                             response.content.cardDetails : {};
          this.tokenExists = this.cardDetails.isfound ? true : false;
          if (this.tokenExists &&
            response.content.basketDetails.isTokenPresent &&
            response.content.basketDetails.isTokenPresent !== '') {
            this.payTokenId = response.content.basketDetails.isTokenPresent;
          }
          this.checkboxEnable = this.tokenExists ? this.tokenExists : false;
          this.tokenPaymentMethod = response.hasOwnProperty('content') ?
                                    response.content.hasOwnProperty('tokenPaymentMethod') ?
                                    response.content.tokenPaymentMethod : '' : '';
          this.payEType = this.tokenPaymentMethod === 'credit card' ? false : true;
          if (this.tokenExists && ! this.payEType) {
            this.tokenCCType = response.hasOwnProperty('content') ?
                               response.content.hasOwnProperty('basketDetails') ?
                               response.content.basketDetails.hasOwnProperty('creditCardType') ?
                               response.content.basketDetails.creditCardType : '' : '' : '';
          }
          const username: string = this.$store.getters.getUserId;
          if (username && username.toUpperCase() === 'GUESTBUYNOW') {
            this.$store.commit('startLoading');
            this.isguestbuynow = true;
            this.useAddress = 'edit';
            this.$nextTick(
              () => {
                this.onEditAddress('edit');
                this.$store.commit('stopLoading');
              },
            );
          }
          this.tokenImgCardType = this.setImgCardType(this.tokenCCType);
          this.steps[0].stepState = 'active';
          this.steps[1].stepState = 'default';
          this.steps[2].stepState = 'default';
        } else {
          if (!this.orderID) {
            this.pushToRoute('/m/feature/cart');
          }
        }
      })
      .catch((errorResponse: any) => {
        this.$store.commit('stopLoading');
        const message: InfoState = {
          infoType: 'high',
          infoMsg: errorResponse.msgDesc ? errorResponse.msgDesc :  this.$t('systemMessages.oprUnSuccss')
          .toString(),
        };
        this.$store.commit('displayMessage', message);
      });
  }

  pushToRoute(routePath: string, routeQuery: any = {}) {
    const subUser = this.$router.currentRoute.query.snbuser ? this.$router.currentRoute.query.snbuser.toString() : '';
    // if ((window as { [key: string]: any }).location.href !== (window as { [key: string]: any }).top.location.href) {
    //   window.parent.postMessage(
    //     {
    //       redirectUrl : this.getRedirectUrl(routePath, routeQuery),
    //     },
    //     '*',
    //   );
    // }
    if (subUser && subUser !== '') {
      this.$router.push({ path: routePath, query: { ...routeQuery, snbuser: subUser } })
        .catch((routeError: any) => {
          console.warn(routeError);
        });
    } else {
      this.$router.push({ path: routePath, query: { ...routeQuery } })
        .catch((routeError: any) => {
          console.warn(routeError);
        });
    }
  }

  replaceRoute(routePath: string, routeQuery: any = {}) {
    const subUser = this.$router.currentRoute.query.snbuser ? this.$router.currentRoute.query.snbuser.toString() : '';
    // if ((window as { [key: string]: any }).location.href !== (window as { [key: string]: any }).top.location.href) {
    //   window.parent.postMessage(
    //     {
    //       redirectUrl : this.getRedirectUrl(routePath, routeQuery),
    //     },
    //     '*',
    //   );
    // }
    if (subUser && subUser !== '') {
      this.$router.replace({ path: routePath, query: { ...routeQuery, snbuser: subUser } })
        .catch((routeError: any) => {
          console.warn(routeError);
        });
    } else {
      this.$router.replace({ path: routePath, query: { ...routeQuery } })
        .catch((routeError: any) => {
          console.warn(routeError);
        });
    }
  }

  getRedirectUrl(path: string, routeQuery: any = {}) {
    let queryParams: string = '';
    if (!_.isEmpty(routeQuery)) {
      const keys: any[] = Object.keys(routeQuery) || [];
      for (let i = 0; i < keys.length; i = i + 1) {
        const key: string = keys[i] || '';
        const keyValue: string = (key && routeQuery[key]) || '';
        queryParams = `${queryParams}${key}=${keyValue}${i === (keys.length - 1) ? '' : '&'}`;
      }
    }
    return `${path}${queryParams !== '' ? '?' : ''}${queryParams}`;
  }

  setBillingAddress() {
    this.addressInfo.fullName = this.basketDetails.hasOwnProperty('fullName') ? this.basketDetails.fullName : '';
    this.addressInfo.company = this.basketDetails.hasOwnProperty('company') ? this.basketDetails.company : '';
    this.addressInfo.emailAddress = this.basketDetails.hasOwnProperty('emailAddress') ? this.basketDetails.emailAddress : '';
    this.addressInfo.phone = this.basketDetails.hasOwnProperty('phoneNumber') ? this.basketDetails.phoneNumber : '';
    this.addressInfo.address1 = this.basketDetails.hasOwnProperty('addressLine1') ? this.basketDetails.addressLine1 : '';
    this.addressInfo.address2 = this.basketDetails.hasOwnProperty('addressLine2') ? this.basketDetails.addressLine2 : '';
    this.addressInfo.city = this.basketDetails.hasOwnProperty('city') ? this.basketDetails.city : '';
    this.addressInfo.country = this.basketDetails.hasOwnProperty('country') ? this.basketDetails.country : '';
    this.addressInfo.state = this.basketDetails.hasOwnProperty('state') ? this.basketDetails.state : '';
    this.addressInfo.province = this.basketDetails.hasOwnProperty('province') ? this.basketDetails.province : '';
    this.addressInfo.zipcode = this.basketDetails.hasOwnProperty('zipCode') ? this.basketDetails.zipCode : '';
    this.addressInfo.isDisable = true;
    this.getCountries();
  }
  onEditAddress(value: any) {
    if (value === 'edit' || value === 'new') {
      this.addressUpdated = true;
      this.addressInfo.isDisable = false;
    } else {
      this.addressInfo.isDisable = true;
    }
  }
  gotoStep1() {
    this.steps[0].stepState = 'active';
    this.steps[1].stepState = 'default';
    this.steps[2].stepState = 'default';
    this.replaceRoute('/m/feature/checkout/billing');
  }
  gotoStep2() {
    this.steps[0].stepState = 'complete';
    this.steps[1].stepState = 'active';
    this.steps[2].stepState = 'default';
    this.replaceRoute('/m/feature/checkout/payment');
  }
  gotoStep3() {
    this.isConditionsRead = true;
    this.isConditionsChecked = false;
    this.steps[0].stepState = 'complete';
    this.steps[1].stepState = 'complete';
    this.steps[2].stepState = 'active';
    this.replaceRoute('/m/feature/checkout/confirmation');
  }
  gotoStep4() {
    this.isOrderConfirmed = true;
    this.steps[0].stepState = 'complete';
    this.steps[1].stepState = 'complete';
    this.steps[2].stepState = 'complete';
    this.replaceRoute('/m/feature/checkout/order_details');
  }
  goBack(step: any) {
    if (step === 1) {
      this.pushToRoute('/m/feature/cart');
    } else if (step === 2) {
      if (!this.useAddress) {
        this.addressInfo.isDisable = true;
      }
      this.$v.cardPaymentForm?.$reset();
      this.$v.echeckPaymentForm?.$reset();
      this.gotoStep1();
    } else if (step === 3) {
      this.isCCDataEditable = true;
      this.enableCCInfoEdit();
      this.gotoStep2();
    } else if (step === 4) {
      this.gotoStep2();
    }
  }
  submitBillings() {
    this.useAddress = 'edit';
    this.onEditAddress('edit');
    if (this.checkIfFormValid()) {
      this.gotoStep2();
    }
  }

  checkIfFormValid() {
    this.$v.addressInfo?.$touch();
    if (!this.$v!.addressInfo!.fullName!.$invalid &&
        this.$v!.addressInfo!.fullName!.required  &&
        !this.$v!.addressInfo!.address1!.$invalid &&
        this.$v!.addressInfo!.address1!.required  &&
        !this.$v!.addressInfo!.address2!.$invalid &&
        !this.$v!.addressInfo!.city!.$invalid &&
        this.$v!.addressInfo!.city!.required &&
        !this.$v!.addressInfo!.zipcode!.$invalid &&
        this.$v!.addressInfo!.zipcode!.required &&
        !this.$v!.addressInfo!.phone!.$invalid &&
        this.$v!.addressInfo!.phone!.required &&
        !this.$v!.addressInfo!.emailAddress!.$invalid &&
        this.$v!.addressInfo!.emailAddress!.required &&
        ((!this.hasStates &&
        !this.$v!.addressInfo!.province!.$invalid &&
        this.$v!.addressInfo!.province!.required) || this.hasStates) &&
        ((this.showVat && !this.$v.addressInfo!.vatNumber!.$invalid) || !this.showVat) &&
        ((this.showGst && !this.$v.addressInfo!.gstNumber!.$invalid) || !this.showGst)) {
      return true;
    }
    return false;
  }
  submitPayments() {
    this.objheader.fullName =  this.addressInfo.fullName ? this.addressInfo.fullName : '';
    this.objheader.addressLine1 = this.addressInfo.address1 ? this.addressInfo.address1 : '';
    this.objheader.addressLine2 = this.addressInfo.address2 ? this.addressInfo.address2 : '';
    this.objheader.addressLine3 = '';
    this.objheader.company = this.addressInfo.company ? this.addressInfo.company : '';
    this.objheader.city = this.addressInfo.city ? this.addressInfo.city : '';
    this.objheader.state = this.addressInfo.state ? this.addressInfo.state : '';
    this.objheader.province = this.addressInfo.province ? this.addressInfo.province : '';
    this.objheader.country =  this.addressInfo.country ? this.addressInfo.country : '';
    this.objheader.zipCode = this.addressInfo.zipcode ? this.addressInfo.zipcode : '';
    this.objheader.phoneNumber = this.addressInfo.phone ? this.addressInfo.phone : '';
    this.objheader.emailAddress = this.addressInfo.emailAddress ? this.addressInfo.emailAddress : '';
    this.objheader.isCreatenew = this.isCreatenew ? this.isCreatenew : false; // revisit
    this.objheader.isSaveAddress = this.isSaveAddress ? this.isSaveAddress : false;
    this.objheader.countryCode = this.addressInfo.country ? this.addressInfo.country : '';
    this.objheader.stateCode = this.addressInfo.state ? this.addressInfo.state : '';
    this.objheader.customerAddressID = this.isCreatenew ? '0' : this.customerAddrID;
    if (this.showVat) {
      this.objheader.vatNumber = this.addressInfo.vatNumber ? this.addressInfo.vatNumber.trim() : '';
      delete this.objheader['gstNumber'];
    }
    if (this.showGst) {
      this.objheader.gstNumber = this.addressInfo.gstNumber ? this.addressInfo.gstNumber.trim() : '';
      delete this.objheader['vatNumber'];
    }
    if (!this.showGst && !this.showVat) {
      delete this.objheader['vatNumber'];
      delete this.objheader['gstNumber'];
    }
    if (!this.tokenExists) {
      if (this.checkIfEcheckFormValid() && this.payWithECheck) {
        // this.frmPaymentWithECheck.controls.dlState.setValue(this.selectedDlState.statecode == "0" ? null : this.selectedDlState.statecode);
        this.objheader.paymentMethod = 'ECHECK';
        this.objheader.bankName = this.echeckPaymentForm.bankName ? this.echeckPaymentForm?.bankName?.trim() : '';
        this.objheader.accountType = this.echeckPaymentForm.eCheckSelectedAcType || 'C';
        this.objheader.routingNumber = this.echeckPaymentForm.routingNo ? this.echeckPaymentForm?.routingNo?.trim()  : '';
        this.objheader.accountNumber = this.echeckPaymentForm?.acNumber?.trim() || '';
        this.objheader.nameOnCard = this.echeckPaymentForm?.nameOnAc?.trim() || '';
        this.objheader.drivingLicenseNumber = this.echeckPaymentForm?.dlNumber?.trim() || '';
        this.objheader.drivingLicenseState = this.echeckPaymentForm.dlState;
        this.objheader.creditCardNum = '';
        this.objheader.creditCardType = '';
        this.$store.dispatch('CheckoutStoreModule/updateBasketHeader', this.objheader)
          .then((response: any) => {
            this.$store.commit('stopLoading');
            if (response.operationStatus === 'OK') {
              this.getBasket();
            } else {
              this.$store.commit('stopLoading');
              const message: InfoState = {
                infoType: 'high',
                infoMsg: response.msgDesc ? response.msgDesc :  this.$t('systemMessages.oprUnSuccss')
                .toString(),
              };
              this.$store.commit('displayMessage', message);
            }
          })
          .catch((errorResponse: any) => {
            this.$store.commit('stopLoading');
            const message: InfoState = {
              infoType: 'high',
              infoMsg: errorResponse.msgDesc ? errorResponse.msgDesc :  this.$t('systemMessages.oprUnSuccss')
              .toString(),
            };
            this.$store.commit('displayMessage', message);
          });
      } else {
        if (this.selectedCardType !== 'none' && this.checkIfCardFormValid()) {
          this.$store.commit('startLoading');
          this.objheader.creditCardType = this.selectedCardType ? this.selectedCardType : 'none';
          this.objheader.creditCardNum = this.cardPaymentForm.cardNumber ?
            this.cardPaymentForm.cardNumber
                .substring(this.cardPaymentForm.cardNumber.length - 4) : '';
          this.objheader.paymentMethod = 'CC';
          this.objheader.isAddressUpdated = this.addressUpdated;
          this.objheader.cardType = this.selectedCardType ? this.selectedCardType : 'none';
          this.objheader.ccNumber = this.cardPaymentForm.cardNumber ? this.cardPaymentForm.cardNumber : '';
          this.objheader.ccExpMonth = this.cardPaymentForm.month ? this.cardPaymentForm.month : '';
          this.objheader.ccExpYear = this.cardPaymentForm.year ? this.cardPaymentForm.year : '';
          this.objheader.cardCVV = this.cardPaymentForm.cvv ? this.cardPaymentForm.cvv : '';
          this.objheader.basketId = this.shoppingCart.id;
          this.objheader.isAutoRenew = this.isAutoRenew;
          this.ccExpDate = `${this.cardPaymentForm.month}/${this.cardPaymentForm.year}`;
          this.$store.dispatch('CheckoutStoreModule/updateBasketHeader', this.objheader)
            .then((response: any) => {
              this.$store.commit('stopLoading');
              if (response.operationStatus === 'OK') {
                this.getBasket();
              } else {
                this.$store.commit('stopLoading');
                const message: InfoState = {
                  infoType: 'high',
                  infoMsg: response.msgDesc ? response.msgDesc :  this.$t('systemMessages.oprUnSuccss')
                  .toString(),
                };
                this.$store.commit('displayMessage', message);
              }
            })
            .catch((errorResponse: any) => {
              this.$store.commit('stopLoading');
              const message: InfoState = {
                infoType: 'high',
                infoMsg: errorResponse.msgDesc ? errorResponse.msgDesc :  this.$t('systemMessages.oprUnSuccss')
                .toString(),
              };
              this.$store.commit('displayMessage', message);
            });
        }
      }
    } else {
      this.$store.commit('startLoading');
      this.objheader.creditCardType = this.basketDetails.creditCardType;
      const cardno = this.basketDetails.creditCardNum;
      this.objheader.creditCardNum = cardno.substring(cardno.length - 4);
      this.objheader.paymentMethod = (this.tokenPaymentMethod === 'credit card') ? 'CC' : 'ECHECK';
      this.objheader.ccexpdate = this.basketDetails.ccExpDate;
      this.objheader.isAutoRenew = this.isAutoRenew;
      if (this.objheader.paymentMethod === 'ECHECK') {
        this.objheader.bankName = this.basketDetails?.bankName;
        this.objheader.accountType = this.basketDetails?.accountType;
        this.objheader.routingNumber = this.basketDetails?.routingNumber;
        this.objheader.accountNumber = this.basketDetails?.accountNumber.substr(this.basketDetails?.accountNumber.length - 4);
        this.objheader.nameOnCard = this.basketDetails.nameOnCard;
        this.objheader.drivingLicenseNumber = '';
        this.objheader.drivingLicenseState = '';
        this.payWithECheck = true;
      }
      this.$store.dispatch('CheckoutStoreModule/updateBasketHeader', this.objheader)
        .then((response: any) => {
          this.$store.commit('stopLoading');
          if (response.operationStatus === 'OK') {
            this.getBasket();
          } else {
            this.$store.commit('stopLoading');
            const message: InfoState = {
              infoType: 'high',
              infoMsg: response.msgDesc ? response.msgDesc :  this.$t('systemMessages.oprUnSuccss')
              .toString(),
            };
            this.$store.commit('displayMessage', message);
          }
        })
        .catch((errorResponse: any) => {
          this.$store.commit('stopLoading');
          const message: InfoState = {
            infoType: 'high',
            infoMsg: errorResponse.msgDesc ? errorResponse.msgDesc :  this.$t('systemMessages.oprUnSuccss')
            .toString(),
          };
          this.$store.commit('displayMessage', message);
        });
    }
  }

  getBasket() {
    this.$store.dispatch('CatalogStoreModule/getBasketDetails', 'YES')
      .then((response: any) => {
        this.$store.commit('stopLoading');
        if (response.operationStatus === 'OK') {
          this.confirmBasketDetails = response.content.basketDetails ? response.content.basketDetails : [];
          this.shoppingCart.tax = response.content.basketDetails.totalTax ? response.content.basketDetails.totalTax : 0;
          this.shoppingCart.price = response.content.basketDetails.totalPrice ? response.content.basketDetails.totalPrice : 0;
          /* Card Tokenization */
          this.confirmBasketDetails.creditCardNum = `************${this.confirmBasketDetails.creditCardNum}`;
          this.tokenExists = response.content.cardDetails.isfound ? true : false;
          this.checkboxEnable = this.tokenExists ? true : false;
          this.cardDetails = response.content.cardDetails || '';
          this.tokenPaymentMethod = response.content.tokenPaymentMethod || '';
          this.customerAddrID = this.confirmBasketDetails.customerAddressID;
          this.payEType = this.tokenPaymentMethod === 'credit card' ? false : true;
          if (this.tokenExists && !this.payEType) {
            this.tokenCCType = response.content.basketDetails.creditCardType || '';
          }
          this.imgCardType = this.setImgCardType(this.tokenCCType);
          /* Card Tokenization */
          this.gotoStep3();
        } else {
          this.$store.commit('stopLoading');
          const message: InfoState = {
            infoType: 'high',
            infoMsg: response.msgDesc ? response.msgDesc :  this.$t('systemMessages.oprUnSuccss')
            .toString(),
          };
          this.$store.commit('displayMessage', message);
        }
      })
      .catch((errorResponse: any) => {
        this.$store.commit('stopLoading');
        const message: InfoState = {
          infoType: 'high',
          infoMsg: errorResponse.msgDesc ? errorResponse.msgDesc :  this.$t('systemMessages.oprUnSuccss')
          .toString(),
        };
        this.$store.commit('displayMessage', message);
      });
  }

  onInputCardNumber(value: any) {
    console.warn(value);
    this.cardPaymentForm.cardNumber = this.cardPaymentForm.cardNumber &&
      this.cardPaymentForm.cardNumber !== '' &&
      this.cardPaymentForm.cardNumber.length > 16 ?
      this.cardPaymentForm.cardNumber.slice(0, 16)
        .trim() :
      this.cardPaymentForm.cardNumber;
    if (this.isCardTypeErr) this.isCardTypeErr = false;
  }

  enableCCInfoEdit() {
    if (this.isCCDataEditable) {
      this.tokenExists = false;
    } else {
      this.tokenExists = true;
    }
  }

  validateCard(onBlur: boolean = false) {
    if (onBlur) {
      // this.ccNoInputTouched = true;
    }
    this.isCardTypeErr = false;
    if (this.cardPaymentForm.cardNumber !== null &&
       this.cardPaymentForm.cardNumber &&
       this.cardPaymentForm.cardNumber.length > 0) {
      this.selectedCardType = RegexValidators.getCreditCardType(this.cardPaymentForm.cardNumber);
      if (this.selectedCardType === 'none') {
        this.isCardTypeErr = true;
      } else {
        this.imgCardType =  this.setImgCardType(this.selectedCardType);
      }
    } else {
      this.selectedCardType = 'none';
      this.imgCardType = '';
    }
  }

  setImgCardType(cardtypes: any) {
    let path: any = '';
    switch (cardtypes) {
      case 'VISA': path =  imageMappings['visa'].path;
        break;
      case 'MAST': path =  imageMappings['mastercard'].path;
        break;
      case 'DISC': path =  imageMappings['discover'].path;
        break;
      case 'AMEX': path =  imageMappings['amex'].path;
        break;
      default: path = '';
    }
    return path;
  }

  handleChangePayMethod() {
    if (this.payWithECheck) {
      this.echeckPaymentForm = { ...initialEcheckPaymentForm };
      this.$v!.echeckPaymentForm!.$reset();
      this.echeckPaymentForm.eCheckSelectedAcType = eCheckAcTypes[0].id.toString();
      this.echeckPaymentForm.dlState = this.getDLStateOptions[0].id.toString();
    } else {
      this.cardPaymentForm  = { ...initialCardPaymentForm };
      this.$v!.cardPaymentForm!.$reset();
      this.cardPaymentForm.year = (new Date()).getFullYear()
      .toString();
      this.cardPaymentForm.month = this.getMonthsOptions && this.getMonthsOptions[0] ? this.getMonthsOptions[0]!.value!.toString() : '01';
    }
  }
  checkIfCardFormValid() {
    this.$v!.cardPaymentForm!.cardNumber!.$touch();
    this.$v!.cardPaymentForm!.cvv!.$touch();
    return !this.$v!.cardPaymentForm!.cardNumber!.$invalid &&
        this.$v!.cardPaymentForm!.cardNumber!.$dirty &&
        this.$v!.cardPaymentForm!.cardNumber!.required &&
        this.$v!.cardPaymentForm!.cardNumber!.minLength &&
        this.$v!.cardPaymentForm!.cvv!.$dirty &&
        !this.$v!.cardPaymentForm!.cvv!.$invalid &&
        this.$v!.cardPaymentForm!.cvv!.required &&
        this.$v!.cardPaymentForm!.cvv!.minLength &&
        !this.isCardTypeErr &&
        this.selectedCardType !== 'none';
  }
  checkIfEcheckFormValid() {
    this.$v!.echeckPaymentForm!.bankName!.$touch();
    this.$v!.echeckPaymentForm!.routingNo!.$touch();
    this.$v!.echeckPaymentForm!.acNumber!.$touch();
    this.$v!.echeckPaymentForm!.dlNumber!.$touch();
    this.$v!.echeckPaymentForm!.nameOnAc!.$touch();
    return !this.$v!.echeckPaymentForm!.bankName!.$invalid &&
          this.$v!.echeckPaymentForm!.bankName!.required  &&
          this.$v!.echeckPaymentForm!.bankName!.$dirty  &&
          this.$v!.echeckPaymentForm!.bankName!.noSpecialCharsExceptSpace  &&
          !this.$v!.echeckPaymentForm!.routingNo!.$invalid  &&
          this.$v!.echeckPaymentForm!.routingNo!.required  &&
          this.$v!.echeckPaymentForm!.routingNo!.$dirty  &&
          this.$v!.echeckPaymentForm!.routingNo!.noSpecialChars  &&
          this.$v!.echeckPaymentForm!.routingNo!.onlyNumeric  &&
          !this.$v!.echeckPaymentForm!.acNumber!.$invalid  &&
          this.$v!.echeckPaymentForm!.acNumber!.required  &&
          this.$v!.echeckPaymentForm!.acNumber!.$dirty  &&
          this.$v!.echeckPaymentForm!.acNumber!.noSpecialChars  &&
          !this.$v!.echeckPaymentForm!.nameOnAc!.$invalid  &&
          this.$v!.echeckPaymentForm!.nameOnAc!.required  &&
          this.$v!.echeckPaymentForm!.nameOnAc!.$dirty  &&
          this.$v!.echeckPaymentForm!.nameOnAc!.noSpecialCharsExceptSpace  &&
          !this.$v!.echeckPaymentForm!.dlNumber!.$invalid  &&
          this.$v!.echeckPaymentForm!.dlNumber!.required  &&
          this.$v!.echeckPaymentForm!.dlNumber!.$dirty  &&
          this.$v!.echeckPaymentForm!.dlNumber!.noSpecialChars;
  }
  editBilling() {
    if (!this.useAddress) {
      this.useAddress = 'edit';
    }
    this.gotoStep1();
  }
  submitConfirmation() {
    if (this.$store.getters.getIsSanboxLoggedIn) {
      this.completeOrder();
    }  else {
      if (this.isConditionsChecked) {
        this.completeOrder();
      } else {
        this.isConditionsRead = false;
      }
    }
  }
  completeOrder() {
    this.$store.commit('startLoading');
    this.completeorderrequest = {
      bankName: '',
      accType: '',
      routingNumber: '',
      enccardetails: '',
      isPOOrder:true,
      accNumber: '',
      accName: '',
      drivingLic: '',
      drivingLicenseState: '',
      paymentMode: '',
      payTokenId: '',
      customerAddressId: this.customerAddrID ? this.customerAddrID : '',
      cardtype: '',
      ccnumber: '',
      ccexpdate: '',
      cvv: '',
    };
    let encryptData = '';
    if (this.isCCDataEditable || this.payTokenId === '') {
      if (this.payWithECheck) {
        this.completeorderrequest.bankName = '';
        this.completeorderrequest.accType = '';
        this.completeorderrequest.routingNumber = '';
        this.completeorderrequest.accNumber = '';
        this.completeorderrequest.accName = '';
        this.completeorderrequest.drivingLic = '';
        this.completeorderrequest.drivingLicenseState = '';
        this.completeorderrequest.paymentMode = 'ECHECK';
        this.completeorderrequest.customerAddressId = this.customerAddrID || '';
        // tslint:disable-next-line
        encryptData = EncryptAesService.encryptText(`${ this.echeckPaymentForm.bankName }^${ this.echeckPaymentForm.eCheckSelectedAcType === 'Checking' ? 'C' : 'S' }^${ this.echeckPaymentForm.routingNo }^${ this.echeckPaymentForm.acNumber }^${this.echeckPaymentForm.nameOnAc }^${ this.echeckPaymentForm.dlNumber }^${ this.echeckPaymentForm.dlState }`).toString();
      } else {
        this.completeorderrequest.cardtype = '';
        this.completeorderrequest.ccnumber = '';
        this.completeorderrequest.ccexpdate = '';
        this.completeorderrequest.cvv = '';
        this.completeorderrequest.paymentMode = 'CC';
        // tslint:disable-next-line
        encryptData = EncryptAesService.encryptText(`${ this.selectedCardType }^${ this.cardPaymentForm.cardNumber }^${ `${this.cardPaymentForm.month}/${this.cardPaymentForm.year}` }^${ this.cardPaymentForm.cvv }`).toString();
      }
      this.completeorderrequest.enccardetails = encryptData;
    } else {
      this.$store.commit('stopLoading');
      this.completeorderrequest.paymentMode = this.objheader.paymentMethod;
      this.completeorderrequest.payTokenId = this.payTokenId;
    }
    this.$store.dispatch('CheckoutStoreModule/completeOrder', { request: { ...this.completeorderrequest }, isfromBuyNow : true })
      .then((response: any) => {
        this.$store.commit('stopLoading');
        if (response.operationStatus === 'OK') {
          this.$store.dispatch('CatalogStoreModule/changeCartCount',  0);
          this.$store.commit('mutate', { property:'cartCount', with:  0 });
          this.orderID = response.content.eorderId ? response.content.eorderId : '';
          this.orderDetailErrorMessage = '';
          if (response.content.isHES) {
            this.replaceRoute('activatehes', { SN: response.content.serialNumber });
          } else {
            this.getOrderDetails(true, response.msgDesc);
          }
        } else {
          if (response.content.eorderId !== undefined) {
            this.orderDetailErrorMessage = response.msgDesc ? response.msgDesc : '';
            this.$store.dispatch('CatalogStoreModule/changeCartCount',  0);
            this.$store.commit('mutate', { property:'cartCount', with:  0 });
            this.orderID = response.content.eorderId ? response.content.eorderId : '';
            if (response.content.isHES) {
              this.replaceRoute('activatehes', { SN: response.content.serialNumber });
            } else {
              this.getOrderDetails(false, response.msgDesc);
            }
          } else {
            this.$store.commit('stopLoading');
            const message: InfoState = {
              infoType: 'high',
              infoMsg: response.msgDesc ? response.msgDesc :  this.$t('systemMessages.oprUnSuccss')
              .toString(),
            };
            this.$store.commit('displayMessage', message);
          }
        }
      })
      .catch((errResponse: any) => {
        this.$store.commit('stopLoading');
        let err: string = '';
        switch (errResponse.status) {
          case 401: err = this.$t('systemMessages.err401')
                              .toString();
            break;
          case 404: err = this.$t('systemMessages.err404')
                              .toString();
            break;
          case 408: err = this.$t('systemMessages.err408')
                              .toString();
            break;
          default:  err = this.$t('systemMessages.server')
                              .toString();
        }
        this.$store.commit('stopLoading');
        const message: InfoState = {
          infoType: 'high',
          infoMsg: err ? err : this.$t('systemMessages.oprUnSuccss')
          .toString(),
        };
        this.$store.commit('displayMessage', message);
      });
  }
  getOrderDetails(success: boolean, msg: string) {
    this.$store.dispatch('CheckoutStoreModule/getOrderDetails', this.orderID)
      .then((response: any) => {
        this.$store.commit('stopLoading');
        if (response.operationStatus === 'OK') {
          this.orderItems = response.content ? response.content : {};
          if (this.orderItems.isdynamicnodecount && this.orderItems.isdynamicnodecount !== '1') {
            this.isFilterUsersColumn = true;
          }
          this.gotoStep4();
          this.$store.dispatch('CatalogStoreModule/changeCartCount',  0);
          this.$store.commit('mutate', { property:'cartCount', with:  0 });
          this.$store.commit('stopLoading');
          const message: InfoState = {
            infoType: 'success',
            infoMsg: response.msgDesc ? response.msgDesc :  this.$t('systemMessages.oprUnSuccss')
            .toString(),
          };
          this.$store.commit('displayMessage', message);
          if (success) {
            const message: InfoState = {
              infoType: 'success',
              infoMsg: `Success!!  ${msg}` };
            this.$store.commit('displayMessage', message);
          } else {
            this.$store.commit('stopLoading');
            const message: InfoState = {
              infoType: 'high',
              infoMsg: msg.toString() };
            this.$store.commit('displayMessage', message);
          }
        } else {
          this.$store.commit('stopLoading');
          const message: InfoState = {
            infoType: 'high',
            infoMsg: response.msgDesc ? response.msgDesc :  this.$t('systemMessages.oprUnSuccss')
            .toString(),
          };
          this.$store.commit('displayMessage', message);
        }
      })
      .catch((errResponse : any) => {
        this.$store.commit('stopLoading');
        let textmessage :string = '';
        switch (errResponse.status) {
          case 401: textmessage = this.$t('systemMessages.err401')
                              .toString();
            break;
          case 404: textmessage = this.$t('systemMessages.err404')
                              .toString();
            break;
          case 408: textmessage = this.$t('systemMessages.err408')
                              .toString();
            break;
          default:  textmessage = this.$t('systemMessages.server')
                              .toString();
        }
        const message: InfoState = { infoType: 'high', infoMsg: textmessage };
        this.$store.commit('displayMessage', message);
      });
  }
  openTerms() {
    const url:string = `${envCongif.contemporary_url}/tos`;
    window.open(url, '_blank');
  }
  onEnterCVV() {
    if (this.cardPaymentForm.cvv) {
      this.cardPaymentForm.cvv = this.cardPaymentForm.cvv.length > 4 ?
      this.cardPaymentForm.cvv.slice(0, 4) :
      this.cardPaymentForm.cvv;
    }
  }
  getCountries() {
    try {
      this.countries = [];
      this.states = [];
      this.$store.commit('startLoading');
      this.$store.dispatch('CheckoutStoreModule/getCountriesFromServer')
        .then((res: any) => {
          this.$store.commit('stopLoading');
          if (res.msgCode === 'MSWAPP:SUCCESS') {
            this.countries = res.content.hasOwnProperty('lstCountries') ?  res.content.lstCountries : [];
            this.addressInfo.country = this.addressInfo.country ?
            this.countries.filter((country: Country) => {
              return country.countryCode === this.addressInfo.country;
            })[0].countryCode :
            this.countries[0].countryCode;
            const isVatRequired = this.countries.filter((cotry: Country) => {
              return cotry.countryCode === this.addressInfo.country;
            })[0].isVatRequired;
            this.showGst = this.countries.filter((country: Country) => {
              return country.countryCode === this.addressInfo.country;
            })[0].isGstRequired;
            this.showVat = isVatRequired ? isVatRequired : false;
            if (this.addressInfo.country === 'US' || this.addressInfo.country === 'CA') {
              this.hasStates = true;
              this.states = this.addressInfo.country === 'US' ? [...StateList.US] :
              this.addressInfo.country === 'CA' ? [...StateList.CA] : [];
              this.addressInfo.state = this.addressInfo.state ?
              this.states.filter((state : State) => {
                return state.stateCode === this.addressInfo.state;
              })[0].stateCode :
              this.states[0].stateCode;
            } else {
              this.hasStates = false;
              this.addressInfo.province = this.addressInfo.province ? this.addressInfo.province : '';
            }
          }
        })
        .catch((errResp: any) => {
          console.error(errResp);
          this.$store.commit('stopLoading');
        });
    } catch (e) {
      console.error(e);
    }
  }
  onChangeCountryValue() {
    this.addressInfo.vatNumber = '';
    this.addressInfo.gstNumber = '';
    this.showVat = this.countries.filter((cotry: Country) => { return cotry.countryCode === this.addressInfo.country; })[0].isVatRequired;
    this.showGst = this.countries.filter((country: Country) => { return country.countryCode === this.addressInfo.country; })[0].isGstRequired;
    if (this.addressInfo.country === 'US' || this.addressInfo.country === 'CA') {
      this.hasStates = true;
      this.states = this.addressInfo.country === 'US' ? [...StateList.US] :
      this.addressInfo.country === 'CA' ? [...StateList.CA] : [];
      this.addressInfo.state = this.addressInfo.state ?
      this.states.filter((state : State) => { return state.stateCode === this.addressInfo.state; })[0].stateCode :
      this.states[0].stateCode;
    } else {
      this.hasStates = false;
      this.addressInfo.province = this.addressInfo.province ? this.addressInfo.province : '';
    }
  }

  descriptionVNode(h: CreateElement, data: { entry: TableEntry }): VNode { // tslint:disable-line
    return (<div style="padding: 10px 5px">
      { data.entry.itemDesc && <div style="white-space: normal;"> { data.entry.itemDesc } </div> }
      { data.entry.serialNumber && <div> { this.$t('checkout.serialNumber') } <span style="color:#2184C7"> { data.entry.serialNumber } </span> </div>}
      { data.entry.ssipn && <div> { this.$t('checkout.partNo')}{ data.entry.ssipn } </div>}
      { data.entry.dispUserAndLicense && <div> { data.entry.dispUserAndLicense } </div> }
    </div>) as VNode;
  }

  activationKeysColumn(h: CreateElement, data: { entry: TableEntry }): VNode { // tslint:disable-line
    return (<div style="padding: 10px 5px">
      { data.entry.arrkeyItems &&
        data.entry.arrkeyItems.length > 0 &&
        data.entry.arrkeyItems.map((arrkeyItem: any) => {
          return (<div>  { arrkeyItem.activationKey }  </div>);
        })
      }
      {
        data.entry.arrkeyItems &&
        data.entry.arrkeyItems.length === 0 && (<div></div>)
      }
    </div>) as VNode;
  }

  statusColumn(h: CreateElement, data: { entry: TableEntry }): VNode { // tslint:disable-line
    return (<div style="padding: 10px 5px">
      { data.entry.arrkeyItems &&
        data.entry.arrkeyItems.length > 0 &&
        data.entry.arrkeyItems.map((arrkeyItem: any) => {
          return (<div>  { arrkeyItem.serviceStatus }  </div>);
        })
      }
      {
        data.entry.arrkeyItems &&
        data.entry.arrkeyItems.length === 0 && (<div></div>)
      }
    </div>) as VNode;
  }
  conditionChanged(value: boolean) {
    if (value) {
      this.isConditionsRead = true;
    }
  }
  print(orderId: string) {
    const url = `${window.location.origin}/workspace/m/orderreceipt?orderId=${orderId}`;
    window.open(url, '_new');
  }
  onclickInfo() {
    const url:string = `${this.transform(envCongif.contemporary_url)}/help/Help.aspx?LOCALE=en&CONTEXT=ORDER&SUBCONTEXT=ECHECK`;
    window.open(url, '_blank');
  }

  public transform(url: string) {
    if (!url) {
      console.error('url is invalid');
      return '';
    }
    return new URL(url).origin;
  }
}
